document.addEventListener("DOMContentLoaded", function () {
  let lastScrollTop = 0;
  console.log("testin bar");
  window.addEventListener(
    "scroll",
    function () {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const announcementWrapper = document.querySelector(
        ".announcement-wrapper"
      );

      if (!announcementWrapper) return;

      if (scrollTop > lastScrollTop) {
        // Scrolling down
        announcementWrapper.classList.add("shopify-section-header-hidden");
        announcementWrapper.classList.remove("shopify-section-header-show");
      } else {
        // Scrolling up
        announcementWrapper.classList.remove("shopify-section-header-hidden");
        announcementWrapper.classList.add("shopify-section-header-show");
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For mobile or negative scrolling
    },
    false
  );
  let lastScrollPosition = 0;
  window.addEventListener("scroll", function () {
    const currentScroll = window.scrollY;

    // Scrolling down
    if (currentScroll > lastScrollPosition) {
      if (currentScroll < 800) {
        document.body.classList.add("scrolling-down");
      } else {
        document.body.classList.remove("scrolling-down");
      }
    }
    // Scrolling up
    else {
      if (currentScroll < 800) {
        document.body.classList.add("scrolling-down");
      } else {
        document.body.classList.remove("scrolling-down");
      }
    }

    lastScrollPosition = currentScroll;
  });
});
